<script lang="ts" setup>
type SocialMediaCard = {
  title: string
  date: string
  media: Record<string, unknown>
  callToAction: Record<string, unknown>
  tag: Record<string, unknown>
}

// type PageCard = {
//   title: string
//   text: string
//   slug: string
//   publishedAt: string
//   media: Record<string, unknown>
//   seo: Record<string, unknown>
//   tag: Record<string, unknown>
// }

type Props = {
  title: string
  text: string
  amountToShow: number
  socialMediaEvents: SocialMediaCard[]
  callToAction: Array<unknown>
}
const { data: pages } = await useContent(getAllArticles)

const _props = defineProps<{ data: Props; theme: string | null | undefined }>()

const { isMobileOrTablet } = useDevice()
const { width: innerWidth } = useWindowSize()

const isMobile = computed(() => {
  if (import.meta.server) return isMobileOrTablet
  return innerWidth.value < 900
})

const visible = ref(false)
// Always show the first 6 items
const alwaysVisible = computed(() => pages.value?.slice(0, _props.data?.amountToShow))
// Only show these items when visible === true
const toggledElements = computed(() => pages.value?.slice(_props.data?.amountToShow))
const emit = defineEmits(['height-change'])

const amount = ref(_props.data?.amountToShow || pages.value?.length)
const toggleVisible = () => {
  visible.value = !visible.value
  amount.value =
    amount.value === pages.value?.length ? _props.data?.amountToShow : pages.value?.length
  setTimeout(() => emit('height-change'), 400)
}
</script>

<template>
  <div class="content-grid relative w-full" :class="{ 'text-(--theme-fg)': theme !== 'gradient' }">
    <div class="mx-bleed relative border-t border-(--theme-fg)/15" />
    <div
      v-if="data.title || data.text"
      class="header grid gap-10"
      :class="{ 'text-(--theme-fg)': theme === 'gradient' }"
    >
      <h2 v-if="data.title" class="ml-bleed my-8 text-sm font-bold uppercase">{{ data.title }}</h2>
      <h3 v-if="data.text" class="ml-bleed font-display mb-10 text-xl lg:mb-15 lg:text-3xl">
        {{ data.text }}
      </h3>
    </div>

    <CarouselsSocialMediaEvents
      v-if="data.socialMediaEvents.length > 0"
      :social-media-events="data.socialMediaEvents"
    />
    <div class="documents px-bleed mt-10 grid gap-(--grid-gap) lg:mt-15">
      <div class="flex flex-row flex-wrap gap-(--grid-gap)">
        <TransitionGroup
          name="fade"
          tag="div"
          class="flex w-full flex-row flex-wrap gap-(--grid-gap)"
        >
          <CardsArticle
            v-for="(article, index) in pages.slice(0, amount)"
            :key="index"
            :article="article"
            :is-highlighted="index % 6 === 0 || index % 6 === 5"
            class="article"
          />
        </TransitionGroup>
      </div>
      <div
        class="buttons inline-flex items-center gap-11.5"
        :class="{ 'text-(--theme-bg)': theme === 'gradient' }"
      >
        <ElementsArrowButton
          class="font-display mt-5 w-fit cursor-pointer outline-none lg:text-lg"
          @click="toggleVisible"
          >{{ visible ? 'View less' : 'View more' }}</ElementsArrowButton
        >
        <ElementsArrowLink
          v-if="data.callToAction && data.callToAction.length > 0"
          :link="data.callToAction[0]"
          class="font-display mt-5 w-fit cursor-pointer outline-none lg:text-lg"
          >{{ data.callToAction[0].label }}</ElementsArrowLink
        >
      </div>
    </div>
  </div>
</template>

<style scoped lang="postcss">
.fade-enter-active,
.fade-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}
</style>
